<div class="widget-inner-alert_wrapper">

    <div class="widget-inner-alert_title">
        {{title | l10n}}
    </div>

    <div class="widget-inner-alert_body">
        {{message | l10n:messageTranslationParams}}
        <span class="order-step-alert_step">
            <span class="order-step-alert_step-value {{stepDisplayDecimal.class}}">{{stepDisplayDecimal.value}}</span>
        </span>
    </div>

    <button type="submit" class="widget-inner-alert_button" (click)="close()">
        {{buttonText | l10n}}
    </button>

    <svg class="widget-inner-alert_close" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
